import { render, staticRenderFns } from "./BaseMediaLibraryItem.vue?vue&type=template&id=558701ea&scoped=true&"
import script from "./BaseMediaLibraryItem.vue?vue&type=script&lang=js&"
export * from "./BaseMediaLibraryItem.vue?vue&type=script&lang=js&"
import style0 from "../Style/base-media-library-item.scss?vue&type=style&index=0&id=558701ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558701ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('558701ea')) {
      api.createRecord('558701ea', component.options)
    } else {
      api.reload('558701ea', component.options)
    }
    module.hot.accept("./BaseMediaLibraryItem.vue?vue&type=template&id=558701ea&scoped=true&", function () {
      api.rerender('558701ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/MediaLibrary/Components/BaseMediaLibraryItem.vue"
export default component.exports